import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { enterAnimation } from 'src/app/shared/animations/enter.animation';
import moment from 'moment';
import { Subscription, Observable } from 'rxjs';
import { AuthenticationService } from 'src/app/core/authentication.service';
import { TasksStates } from 'src/app/core/enums/tasksStates';
import { AttentionType } from 'src/app/core/enums/attentionType';
import { EvolutionsType } from 'src/app/core/enums/temporalEvolutionType';
import { FileUtilitiesService } from 'src/app/core/services/fileUtilities.service';
import { CustomValidators } from 'src/app/core/validators/custom-validators';
import { DialogEndTaskComponent } from 'src/app/modules/tasks/components/dialog-end-task/dialog-end-task.component';
import { Attention } from 'src/app/shared/models/attention';
import { Evolution } from 'src/app/shared/models/evolution';
import { EvolutionExcel } from 'src/app/shared/models/evolutionExcel';
import { StateTask } from 'src/app/shared/models/stateTask';
import { Task } from 'src/app/shared/models/task';
import { User } from 'src/app/shared/models/user';
import Swal from 'sweetalert2';
import { EntitiesFacade } from 'src/app/abstraction/entities.facade';
import { Case } from 'src/app/shared/models/case';
import { AttentionComposedWithEvolutions, EvolutionsFacade } from 'src/app/abstraction/evolutions.facade';
import { PostEvolutionBody, EvolutionsService } from '../../../../core/services/evolutions.service';
import { EvolutionCategoryId } from '../../../../core/enums/evolutionAi';
import { EvolutionAiAnalysis } from 'src/app/shared/models/evolutionAiAnalysis';
import { RateEvolutionDialogComponent } from '../rate-evolution-dialog/rate-evolution-dialog.component';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';
import { CategoryOfEvolution } from 'src/app/shared/models/categoryOfEvolution';
import { AlertService } from 'src/app/core/services/alert.service';
import mime from 'mime';
import { CategoriesofEvolutionsFacade } from 'src/app/abstraction/categories-of-evolutions.facade';
import { MatSelectChange } from '@angular/material/select';
import { EvolutionPdfQPS } from 'src/app/abstraction/cases.facade';
import { CaseDateFilters, CasesFacade } from '../../../../abstraction/cases.facade';
import { DialogImageDetailComponent } from '../../../../shared/components/dialog-image-detail/dialog-image-detail.component';
import { DateService } from 'src/app/core/services/date.service';
import { ExperienceI18nService } from 'src/app/core/experience/experience-i18n.service';
import { AttentionsQPS } from 'src/app/core/services/attentions.service';
import { ProvisionsFacade } from 'src/app/abstraction/provisions.facade';
import { ProvisionAgreementFilters } from 'src/app/shared/models/ProvisionAgreementFilters';
import { FilePondComponent } from 'ngx-filepond';
import { Operator } from 'src/app/shared/models/operator';

enum LogoOptions {
    NO_LOGO = '1',
    COMPANY_LOGO = '2',
    CUSTOM_LOGO = '3',
    ADOMICILIO_LOGO = '4',
}

enum OutputOptions {
    UNIQUE_FILE = '1',
    BY_PRACTICE = '2',
    BY_PROVIDER_PRACTICE = '3',
}

enum OPTIONS_TO_EXPORT {
    PDF = 'pdf',
    ZIP = 'zip',
    CSV = 'csv',
}
@Component({
    selector: 'app-evolutions',
    templateUrl: './evolutions.component.html',
    styleUrls: ['./evolutions.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        enterAnimation,
    ],
})

export class EvolutionsComponent implements OnInit {

    @Input() data: { name: string; surname: string; typeDocument: string, document: string; cif: number; };
    @Input() case: Case;

    // @Input() categoriesSelected;
    categoriesSelected = [];
    isAddingTask: boolean = false;
    attentionsWithoutDayRepeat: AttentionComposedWithEvolutions[];
    evolutions: Evolution[];
    evolutionsSubscribed: Evolution[];
    EVOLUTIONS_TYPE = EvolutionsType;
    onSubmitExportFunction;
    notesPreviousLenght;
    evolutionsPdf: AttentionComposedWithEvolutions[];
    loadingConfirmEndTask;
    indexPanelOpened = -1;
    fragment: string;
    case$: Subscription;
    userSubscription: Subscription;
    user: User;
    showOptions = false;
    practices = [];
    OPTIONS_TO_EXPORT = OPTIONS_TO_EXPORT;
    objectValues = Object.values;
    _evolutionByCase: Subscription;
    dataEvolutionsWithNotes: { [key: number]: Evolution[] };
    notesSubscriptionInitialized = false;
    public LOGO_OPTIONS = LogoOptions;
    public OUTPUT_OPTIONS = OutputOptions;
    evolutionsContainerId: string;
    evolutions$: Observable<AttentionComposedWithEvolutions[]>; _evolutions: Subscription;
    attentions$: Observable<Attention[]>;
    _attentions: Subscription;
    _evolutionsTypeNote: Subscription;
    caseDateFilters$: Observable<CaseDateFilters>; _caseDateFilters: Subscription;
    caseDateFilters: CaseDateFilters;
    attentions: AttentionComposedWithEvolutions[];
    attentionsPreviousFilter: AttentionComposedWithEvolutions[];
    attentionsSubscribed: AttentionComposedWithEvolutions[];
    operators: Operator[];
    _operators: Subscription;
    @ViewChildren('evolutionContainer') components: QueryList<ElementRef>;

    isLoadingGettingEvolutions$: Observable<boolean>;
    isloadingGettingMedia: boolean;
    evolutionIdGettingMedia: number;
    _isLoadingGettingMedia: Subscription;

    // Temporary holder for the mat-menu context to ensure we always have the expected objects
    menuEvolutionContext: { evolution?: Evolution, attention?: Attention } = {};

    filtersOnProvisions$: Observable<ProvisionAgreementFilters>;
    _filtersOnProvisions: Subscription;
    filterOnProvisions: ProvisionAgreementFilters;


    //FORM
    public readonly DATE_FROM = 'fromDate';
    public readonly DATE_TO = 'toDate';
    public readonly LOGO = 'logo';
    public readonly LOAD_FILE = 'loadFile';
    public readonly OUTPUT_TYPE = 'exportType';
    public readonly VISIBLE_PROVIDER = 'visibleProvider';
    public readonly VISIBLE_FINANCIER = 'visibleFinancier';

    exportForm: FormGroup;
    filterForm: FormGroup;

    elementsLogo = [
        {
            id: LogoOptions.NO_LOGO,
            name: this.experienceI18n.translate('modules.cases.evolutions.export.logo.no-logo', undefined, 'Sin logo'),
        },
        {
            id: LogoOptions.COMPANY_LOGO,
            name: this.experienceI18n.translate('modules.cases.evolutions.export.logo.company-logo', undefined, 'Logo de la empresa'),
        },
        {
            id: LogoOptions.CUSTOM_LOGO,
            name: this.experienceI18n.translate('modules.cases.evolutions.export.logo.custom-logo', undefined, 'Logo personalizado'),
        }
    ];

    elementsOutput = [
        {
            id: OutputOptions.UNIQUE_FILE,
            name: this.experienceI18n.translate('modules.cases.evolutions.export.output.unique-file', undefined, 'Único archivo'),
        },
        {
            id: OutputOptions.BY_PRACTICE,
            name: this.experienceI18n.translate('modules.cases.evolutions.export.output.by-practice', undefined, 'Separado por práctica'),
        },
        {
            id: OutputOptions.BY_PROVIDER_PRACTICE,
            name: this.experienceI18n.translate('modules.cases.evolutions.export.output.by-provider-practice', undefined, 'Separado por práctica y prestador'),
        }
    ];
    cont: number = 0;

    // Evolution Create Dialog
    @ViewChild('addEvolutionForCase', { static: true }) addEvolutionForCase: TemplateRef<any>;
    modifyEvolutionForAttention: TemplateRef<DialogEndTaskComponent>;
    _dialogRef;
    updatingEvolution: boolean;
    evolutionToUpdate: Evolution;

    @ViewChild('myPond') myPond: FilePondComponent;
    photoEvolutionB64: any;
    loadingAddFile: boolean = false;
    evolutionForm: FormGroup;
    showVisibilityCheckbox: boolean;
    public fileExported: Subscription;
    _isLoadingEvolutionsPdf: Subscription;
    pdfSpinner$: Observable<boolean>;

    get evolutionText() {
        return this.evolutionForm.get(this.EVOLUTION_TEXT);
    }
    get evolutionType() {
        return this.evolutionForm.get(this.EVOLUTION_TYPE);
    }
    set evolutionText(value) {
        this.evolutionForm.get(this.EVOLUTION_TEXT).setValue(value);
    }
    set evolutionType(value) {
        this.evolutionForm.get(this.EVOLUTION_TYPE).setValue(value);
    }

    public readonly EVOLUTION_TEXT = 'evolution_text';
    public readonly EVOLUTION_TYPE = 'evolution_type';
    public readonly ADD_TASK = 'addTask';
    public readonly OPERATOR = 'operator';
    public readonly OPERATOR_SEARCHING = 'operator_searching';



    loadingConfirm = false;
    financierVisibility: boolean;
    providersVisibility: boolean;
    listEvolutionTypes: CategoryOfEvolution[];

    private defaultTextCharged: string;
    private changeTextDescription: boolean;

    pondOptions = {
        class: 'my-filepond',
        multiple: false,
        labelIdle: this.experienceI18n.translate('modules.cases.evolutions.filepond.label-idle', undefined, 'Arrastre el archivo o haga click <u>aquí</u>'),
        labelFileTypeNotAllowed: this.experienceI18n.translate('modules.cases.evolutions.filepond.label-file-type-not-allowed', undefined, 'Tipo de archivo inválido'),
        fileValidateTypeLabelExpectedTypes: this.experienceI18n.translate('modules.cases.evolutions.filepond.label-expected-types', undefined, 'Formatos aceptados: jpg, jpeg, png, pdf'),
        acceptedFileTypes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'],
        allowImagePreview: true,
        imagePreviewMaxHeight: 150,
        maxFileSize: this.experienceI18n.translate('modules.cases.evolutions.filepond.max-file-size', undefined, '10MB')
    };


    get dateFromForm() {
        return this.filterForm.get(this.DATE_FROM).value;
    }
    get dateToForm() {
        return this.filterForm.get(this.DATE_TO).value;
    }
    get logoForm() {
        return this.exportForm.get(this.LOGO).value;
    }
    get loadFileForm() {
        return this.exportForm.get(this.LOAD_FILE).value;
    }
    set dateFromForm(date: Date) {
        date != null ? this.filterForm.get('fromDate').setValue(date) : this.filterForm.get('fromDate').reset();
    }
    set dateToForm(date: Date) {
        date != null ? this.filterForm.get('toDate').setValue(date) : this.filterForm.get('toDate').reset();
    }
    set optionLogoForm(optionLogoId: number) {
        optionLogoId != null ? this.exportForm.controls[this.LOGO].setValue(optionLogoId.toString()) : this.exportForm.controls[this.LOGO].reset()
    }

    emptyAttentions: boolean = true;

    readonly EVOLUTION_CATEGORY = EvolutionCategoryId;
    aiAnalysisCache = new Map<number, EvolutionAiAnalysis>();
    aiExpandedIds = new Set<number>();
    /** Display name of who rated (not yet persisted on backend). */
    auditorNameByEvolutionId = new Map<number, string>();

    constructor(
        public fileUtilitiesService: FileUtilitiesService,
        public entitiesFacade: EntitiesFacade,
        private cd: ChangeDetectorRef,
        public dialog: MatDialog,
        private sanitizer: DomSanitizer,
        public router: Router,
        private route: ActivatedRoute,
        private formBuilder: FormBuilder,
        private authService: AuthenticationService,
        private evolutionsFacade: EvolutionsFacade,
        private alertService: AlertService,
        private categoriesOfEvolutionFacade: CategoriesofEvolutionsFacade,
        private casesFacade: CasesFacade,
        private dateService: DateService,
        private provisionsFacade: ProvisionsFacade,
        private experienceI18n: ExperienceI18nService,
        private evolutionsService: EvolutionsService,
    ) {
        this.evolutions$ = this.evolutionsFacade.getAttentionsWithEvolutions$();
        this.isLoadingGettingEvolutions$ = this.evolutionsFacade.isLoadingGetEvolutions$();
    }

    ngOnInit() {
        this.evolutionForm = this.createEvolutionForm();
        this.userSubscription = this.authService.getUser$().subscribe((user) => (this.user = user));
        this.filterForm = this.createFilterForm();
        this.getNotes();
        this.subscribeToData();
        this.suscribeToOperatorsData();
        this.route.fragment.subscribe(fragment => { this.fragment = fragment });
        this.pdfSpinner$ = this.casesFacade.isLoadingGetEvolutionsPdf$();

        this.evolutionForm.get(this.ADD_TASK)?.valueChanges.subscribe(value => {
            if (value) {
                this.isAddingTask = true;
            } else {
                this.isAddingTask = false;
            }
        });
        this.operatorValidator()

        // Subscribe to media-loading flag so we can show per-evolution spinners
        this._isLoadingGettingMedia = this.evolutionsFacade.isLoadingGettingMedia$().subscribe(loadingMedia => {
            this.isloadingGettingMedia = loadingMedia;
        });

    }

    isModuleAttention(attention: Attention): boolean {
        return attention?.type === AttentionType.MODULE;
    }

    ngAfterViewInit(): void {
        try {
            document.querySelector('#' + this.fragment).scrollIntoView();
        } catch (e) { }
        console.log(this.components.toArray());
    }

    ngOnDestroy(): void {
        if (!!this._evolutions) {
            this._evolutions.unsubscribe();
        }
        if (!!this._evolutionsTypeNote) {
            this._evolutionsTypeNote.unsubscribe();
        }
        if (!!this._attentions) {
            this._attentions.unsubscribe();
        }
        this._caseDateFilters ? this._caseDateFilters.unsubscribe() : null;
        this._filtersOnProvisions ? this._filtersOnProvisions.unsubscribe() : null;

        if (this._isLoadingGettingMedia) {
            this._isLoadingGettingMedia.unsubscribe();
        }

        this.evolutionsFacade.setAttentionsWithEvolutions(null);

    }

    onClickNavigateToAttention(event: Event, attention: AttentionComposedWithEvolutions) {
        event.preventDefault();
        const id = (attention.id) ? attention.id : attention.evolutions[0]?.id;
        if (!id) return;
        // update URL fragment without navigating away
        this.router.navigate([], { fragment: id.toString(), replaceUrl: true });
        // smooth scroll to element
        setTimeout(() => {
            const el = document.getElementById(id.toString());
            if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 50);
    }

    operatorValidator(): void {
        const addTaskControl = this.evolutionForm.get(this.ADD_TASK);
        const operatorControl = this.evolutionForm.get(this.OPERATOR);

        addTaskControl.valueChanges.subscribe((value: boolean) => {
            if (value) {
                operatorControl.setValidators([CustomValidators.required(this.experienceI18n.translate('modules.cases.evolutions.validators.operator-required', undefined, 'Operador requerido'))]);
            } else {
                operatorControl.clearValidators();
            }
            operatorControl.updateValueAndValidity();
        });

    }

    calculateIdOperator = (operator: Operator) => {
        return (operator) ? operator.id : null;
    }

    calculateNameOperator = (operator: Operator) => {
        return (operator) ? operator.name + ' ' + operator.surname : null;
    }

    suscribeToOperatorsData() {
        this._operators = this.entitiesFacade.loadOperators({ active: true }, true).subscribe((operators: Operator[]) => {
            this.operators = operators;
        })
    }


    subscribeToData() {

        this._caseDateFilters = this.casesFacade.getCaseDateFilters$().subscribe(filters => {
            this.caseDateFilters = filters;
            let attentionQPS: AttentionsQPS = { casesIds: [this.case.id] };
            attentionQPS.expand = 'financier,practice,provider';
            if (!!this.caseDateFilters) {
                attentionQPS.fromDate = this.caseDateFilters.historyFromDate;
                attentionQPS.toDate = this.caseDateFilters.historyToDate;
            }
            attentionQPS.withMedia = false;
            attentionQPS.page = 0;
            attentionQPS.size = 2000;

            this.evolutionsFacade.loadAttentionsWithEvolutionsByQPS(attentionQPS, this.categoriesSelected);
        })


        this._evolutions = this.evolutions$.subscribe(evolutions => {
            this.attentions = evolutions;
            // DEBUG: log a sample to inspect hasMedia/media flags when troubleshooting
            try {
                console.log('Evolutions sample for debug:', (this.attentions && this.attentions.length) ? this.attentions[0] : this.attentions);
            } catch (e) { }
            if (!!this.attentions) {
                this.attentions = this.attentions.filter(att => !!att.evolutions && att.evolutions.length > 0);
                this.attentionsPreviousFilter = evolutions;
                this.loadAttentionsAndEvolution();
                this.filterEvolutions();
                this.cd.detectChanges();
            }
        })

        this.categoriesOfEvolutionFacade.loadCategoriesOfEvolutions({ active: 1 }, true).subscribe();
        this.categoriesOfEvolutionFacade.getCategoriesOfEvolutions$().subscribe(
            evolutionCategories => this.listEvolutionTypes = evolutionCategories?.filter(evoCat => !evoCat.category?.includes('NOTA_'))
        );

        this.filtersOnProvisions$ = this.provisionsFacade.getFiltersOnProvisions$();
        this._filtersOnProvisions = this.filtersOnProvisions$.subscribe(filters => {
            this.filterOnProvisions = filters;
            if (!!this.attentions) {
                this.filterEvolutions()
            }
        })
    }


    getNotes() {
        if (this._evolutionsTypeNote) {
            this._evolutionsTypeNote.unsubscribe();
        }
        this.notesPreviousLenght = !!this.dataEvolutionsWithNotes ? Object.keys(this.dataEvolutionsWithNotes).length : 0;
        this._evolutionsTypeNote = this.evolutionsFacade.getEvolutionsTypeNote$().subscribe((evo: { [key: number]: Evolution[] }) => {
            this.dataEvolutionsWithNotes = evo;
            const newLenght = Object.keys(evo ?? {}).length;
            if (!this.notesSubscriptionInitialized) {
                this.notesSubscriptionInitialized = true;
                this.notesPreviousLenght = newLenght;
                return;
            }
            if (newLenght > this.notesPreviousLenght) {
                this.notesPreviousLenght = newLenght;
                this.emulateAddNote(evo);
                return;
            }
            this.notesPreviousLenght = newLenght;
        });
    }

    //Temporarily show the note in the evolution list
    emulateAddNote(evo) {
        const keysStr = Object.keys(evo);
        if (keysStr.length === 0) {
            return undefined;
        }
        const lastNoteKeyStr = keysStr[keysStr.length - 1];
        const lastNoteKey = Number(lastNoteKeyStr);
        const lastEvolution = evo[lastNoteKey];
        const newEvo = lastEvolution[0];
        if (this.hasEvolutionLoaded(newEvo?.id)) {
            return;
        }
        this.emulateAttentionWithEvolution(newEvo);
        return;
    }

    filterEvolutions() {
        let attentionsLoaded: AttentionComposedWithEvolutions[];
        this.attentionsPreviousFilter = !!this.attentionsPreviousFilter ? this.attentionsPreviousFilter : [...this.attentions];

        const filters = this.filterOnProvisions;

        if (!!filters?.modulesFlow) {
            attentionsLoaded = this.filterEvolutionsModulesFlow(filters);
        } else {
            attentionsLoaded = this.filterEvolutionsStandardFlow(filters);
        }

        this.attentions = attentionsLoaded;
        if (!!this.categoriesSelected && this.categoriesSelected.length > 0) {
            this.attentions = this.attentions.map(att => {
                let evolutionsFiltered = att?.evolutions?.filter(ev => this.categoriesSelected?.includes(`${ev?.category?.id}`))
                return { ...att, evolutions: evolutionsFiltered }
            })
        }
        this.attentions = this.attentions?.filter(att => !!att.evolutions && att.evolutions.length > 0);
        this.loadAttentionsAndEvolution();
        this.cd.detectChanges();

    }

    /**
     * Modules flow: filter by AttentionType (MODULE / PRACTICE_MODULE)
     * - Solo caseModuleIds → MODULE attentions de esos módulos
     * - provisionFees seleccionados → PRACTICE_MODULE attentions que matcheen provisionFeeId (+ agreement si hay)
     * - caseModuleIds + provisionFees → union de ambos
     * - Nada seleccionado → todas las atenciones
     */
    private filterEvolutionsModulesFlow(filters: ProvisionAgreementFilters): AttentionComposedWithEvolutions[] {
        const source = this.attentionsPreviousFilter;

        const hasCaseModuleIds = filters?.caseModuleIds?.length > 0;
        const hasProvisionFees = filters?.provisionFees?.length > 0;
        const hasAgreements = filters?.agreements?.length > 0;
        const hasOrders = filters?.orders?.length > 0;
        const hasAnyFilter = hasCaseModuleIds || hasProvisionFees || hasAgreements || hasOrders;

        if (!hasAnyFilter) {
            return [...source];
        }

        let result: AttentionComposedWithEvolutions[] = [];

        // 1. MODULE type attentions filtered by caseModuleIds
        if (hasCaseModuleIds) {
            const caseModuleIdSet = new Set(filters.caseModuleIds);
            const moduleAttentions = source.filter(att =>
                att.type === AttentionType.MODULE && caseModuleIdSet.has(att.caseModuleId)
            );
            result.push(...moduleAttentions);
        }

        // 2. PRACTICE_MODULE type attentions filtered by provisionFees (+ agreements)
        if (hasProvisionFees) {
            const provisionFeeIdSet = new Set(filters.provisionFees.map(pf => pf.id));
            const practiceModuleBase = source.filter(att => att.type === AttentionType.PRACTICE_MODULE);

            let practiceModuleAttentions: AttentionComposedWithEvolutions[];

            if (hasAgreements) {
                const agreementIdSet = new Set(filters.agreements.map(ag => ag.id));
                practiceModuleAttentions = practiceModuleBase.filter(att =>
                    this.matchesProvisionFee(att, provisionFeeIdSet) && agreementIdSet.has(att.agreementId)
                );
            } else {
                practiceModuleAttentions = practiceModuleBase.filter(att =>
                    this.matchesProvisionFee(att, provisionFeeIdSet)
                );
            }
            result.push(...practiceModuleAttentions);
        } else if (hasCaseModuleIds && !hasProvisionFees) {
            // Solo módulos seleccionados sin prácticas → también mostrar PRACTICE_MODULE de esos módulos
            const caseModuleIdSet = new Set(filters.caseModuleIds);
            const practiceModulesForSelectedModules = source.filter(att =>
                att.type === AttentionType.PRACTICE_MODULE && caseModuleIdSet.has(att.caseModuleId)
            );
            result.push(...practiceModulesForSelectedModules);
        }

        // 3. Orders (insumos)
        if (hasOrders) {
            const orderAgreementIds = new Set(
                filters.orders.map(or => (or as any)?.agreement?.id).filter(id => id != null)
            );
            const orderAttentions = source.filter(att =>
                att.isSupply && orderAgreementIds.has(att.agreementId)
            );
            result.push(...orderAttentions);
        }

        return result;
    }

    /**
     * Standard flow (non-modules): filter by provisionFees, agreements, orders
     */
    private filterEvolutionsStandardFlow(filters: ProvisionAgreementFilters): AttentionComposedWithEvolutions[] {
        const source = this.attentionsPreviousFilter;

        if (!filters) {
            return [...source];
        }

        const hasAgreements = filters.agreements?.length > 0;
        const hasProvisionFees = filters.provisionFees?.length > 0;
        const hasOrders = filters.orders?.length > 0;

        if (hasAgreements || hasProvisionFees) {
            if (hasAgreements && !hasProvisionFees) {
                return source.filter(att =>
                    filters.agreements.some(ag => ag.id == att.agreementId)
                );
            }

            if (hasProvisionFees && !hasAgreements) {
                const provisionFeeIdSet = new Set(filters.provisionFees.map(pf => pf.id));
                return source.filter(att => this.matchesProvisionFee(att, provisionFeeIdSet));
            }

            // Both agreements and provisionFees
            const provisionFeeIdSet = new Set(filters.provisionFees.map(pf => pf.id));
            const agreementIdSet = new Set(filters.agreements.map(ag => ag.id));
            return source.filter(att =>
                this.matchesProvisionFee(att, provisionFeeIdSet) && agreementIdSet.has(att.agreementId)
            );
        }

        if (hasOrders) {
            return source.filter(att => filters.orders.some(or =>
                or?.agreement?.id == att?.agreementId
                ||
                (!!att.provisionFeeIds ? or.items.some(item => att.provisionFeeIds.includes(item.provisionFeeId)) : false)
            ));
        }

        return [...source];
    }

    private matchesProvisionFee(att: AttentionComposedWithEvolutions, provisionFeeIdSet: Set<number>): boolean {
        return provisionFeeIdSet.has(att.provisionFeeId)
            || (!!att.provisionFeeIds && att.provisionFeeIds.some(id => provisionFeeIdSet.has(id)));
    }

    setAttentionForNav() {

        this.attentionsWithoutDayRepeat = [...new Set(this.attentions)]
        for (var i = this.attentionsWithoutDayRepeat.length - 1; i >= 1; i--) {
            if (moment(this.attentionsWithoutDayRepeat[i].fromDate).isSame(this.attentionsWithoutDayRepeat[i - 1].fromDate, 'day')) {
                this.attentionsWithoutDayRepeat.splice(i, 1);
            }
        }
    }

    sortEvolutionsByAttentionDate() {
        this.attentions.sort((a, b) => {
            if (a && a.fromDate) {
                const aFromDate = moment(a.fromDate);
                const bFromDate = moment(b.fromDate);
                return aFromDate.isSame(bFromDate) ? 0 : (aFromDate.isBefore(bFromDate) ? 1 : -1);
            }
            return -1;
        });
    }

    mapAttentionEvolution() {
        this.attentions = this.attentionsSubscribed?.map(attention => {
            let evolution: Evolution[] = this.evolutionsSubscribed?.filter((evol) => attention.id && evol.attentionId === attention.id)
            attention.evolutions = this.filterDisplayEvolutions(evolution);
            return attention;
        }).filter(att => !!att.evolutions && att.evolutions.length > 0);

        let arrayAttentionsId = this.attentions?.map(attentions => attentions.id);

        this.evolutionsSubscribed?.filter(evolution => (!evolution.attentionId)).forEach(evol => {
            if (!this.attentions) {
                this.attentions = [];
            }
            let attention: AttentionComposedWithEvolutions = {
                fromDate: evol.date,
                caseId: evol.caseId,
                evolutions: [evol]
            }
            this.attentions.push(attention);
        });

        /* Finding evolutions for consent attentions - Must shows too */
        this.evolutionsSubscribed?.filter(evolution => !!evolution.attentionId && !arrayAttentionsId?.includes(evolution.attentionId)).forEach(evol => {
            if (!this.attentions) {
                this.attentions = [];
            }
            let attention: AttentionComposedWithEvolutions = {
                fromDate: evol.date,
                caseId: evol.caseId,
                evolutions: [evol],
                id: evol.attentionId
            }
            this.attentions.push(attention);
        });

        if (this.attentions.length > 0) {
            this.emptyAttentions = false;
        }
    }

    setCountPractices(practiceId) {
        if (this.practices.length == 0) {
            this.practices.push({ id: practiceId, count: 1 });
        } else {
            let practiceIndex = this.practices.findIndex(practice => practice.id == practiceId);
            if (practiceIndex > -1) {
                this.practices[practiceIndex].count += 1;
            } else {
                this.practices.push({ id: practiceId, count: 1 });
            }
        }
    }

    mapAttentionsPractices() {
        this.attentions.filter(attention => !!attention.id).forEach(attention => {
            if (attention?.state?.id != 6) {
                if (attention?.practiceId) {
                    this.setCountPractices(attention.practiceId);
                }
            }
        });
        this.filterPractices();
    }

    mapAttentionsPracticesToExport(attentions) {
        attentions.filter(attention => !!attention.id).forEach(attention => {
            if (attention?.state?.id != 6) {
                if (attention?.practiceId) {
                    this.setCountPractices(attention.practiceId);
                }
            }
        });
        this.filterPractices();
    }

    filterPractices() {
        this.practices.forEach(practice => {
            this.attentions.filter(attention => !!attention.id).forEach(att => {
                if (att?.practice?.id == practice.id) {
                    practice['name'] = att.practice.name;
                }
            })
        });
    }

    sanitizeUrl(url) {
        return this.sanitizer.bypassSecurityTrustUrl(url);
    }

    openDialogImage(_image): void {
        const dialogRef = this.dialog.open(DialogImageDetailComponent, {
            width: '50%',
            data: { image: _image },
        });

        dialogRef.afterClosed().subscribe((result) => {
        });
    }

    openDialogModifyEvolution(evolution: Evolution, attention: Attention) {
        // Defensive guard: try to recover missing attention from evolution.attentionId or component attentions
        if (!evolution) {
            console.error('openDialogModifyEvolution called with invalid evolution param', { evolution, attention });
            return;
        }
        if (!attention) {
            // try to resolve attention from the evolution object
            if (evolution.attentionId) {
                attention = this.getAttentionById(evolution.attentionId);
            } else if ((this.attentions || []).length > 0) {
                // as a last resort try to find an attention that contains this evolution by id
                attention = this.attentions.find(att => att.evolutions?.some(ev => ev.id === evolution.id));
            }
            if (!attention) {
                console.warn('openDialogModifyEvolution could not resolve attention for evolution, opening create dialog fallback', evolution);
                // fallback: open create dialog instead of modifying
                this.openCreateEvolution();
                return;
            }
        }

        evolution.attention = attention;
        evolution.attentionId = attention.id;
        evolution.financier = attention.financier;
        let stateTask: StateTask = {
            id: TasksStates.FINISHED,
        }
        let task: Task = {
            state: stateTask,
            evolution,
        }
        this.updatingEvolution = true;
        this.evolutionToUpdate = evolution
        let dialogRef = undefined;
        this.evolutionForm = this.createEvolutionForm();
        this.operatorValidator();

        if (!!this.updatingEvolution && this.evolutionToUpdate) {
            this.financierVisibility = this.evolutionToUpdate.visibleFinancier;
            this.providersVisibility = this.evolutionToUpdate.visibleProvider;
            if (this.evolutionToUpdate.mediaUrls) {
                this.photoEvolutionB64 = this.evolutionToUpdate.mediaUrls[0];
            }
            if (this.evolutionToUpdate.category) {
                this.evolutionType.setValue(this.evolutionToUpdate.category.id);
            }
        }
        if (attention.id) {
            /* this.openDialog(
               'Dar de alta un formulario',
               this.modifyEvolutionForAttention,
               { maxHeight: '95vh', minWidth: '65%' },
               (result) => {
                  if (result) {
                     this.onFinishTask(result);
                  }
               }
            ); */
            dialogRef = this.dialog.open(DialogEndTaskComponent, {
                width: '65%',
                maxHeight: '95vh',
                data: {
                    task,
                    modifyEvolution: true,
                },
            });
            dialogRef.afterClosed().subscribe((result) => {
                if (result) {
                    this.onFinishTask(result);
                }
            });
        } else {
            this.openDialog(
                this.case,
                this.experienceI18n.translate('modules.cases.evolutions.dialog.evolve-title', undefined, 'Evolucionar'),
                this.addEvolutionForCase,
                { maxHeight: '95vh', minWidth: '65%' },
                () => { }
            );
        }
    }

    onFinishTask(data: {
        task: Task;
        visibility: {
            financier: boolean;
            providers: boolean;
        };
        attentionState?: number;
        evolutionOperator?: PostEvolutionBody;
    }) {
        // 1- Patch a /user/evolutions/:id modificando la visibilidad
        // 2- Si attentionState!=null -> Patch a /user/attentions/:id modificando el estado
        // 3- Si todo termina bien -> Patch a /user/tasks/:id modificando el estado de la tarea a finalizada
        // const newTask: Task = {
        //    ...data.task,
        //    evolution: {
        //       ...data.task.evolution,
        //       visibleFinancier: data.visibility.financier,
        //       visibleProvider: data.visibility.providers,
        //    },
        // };

        const evolution: Evolution = {
            id: data.task.evolution.id,
            visibleProvider: data.visibility.providers,
            visibleFinancier: data.visibility.financier,
        };

        const swalWithCustomizeButtons = Swal.mixin({
            customClass: {
                confirmButton: 'btnSwalConfirm',
                cancelButton: 'btnSwalCancel'
            },
            buttonsStyling: true
        })

        this.evolutionsFacade.patchEvolution(evolution).toPromise()
            .then((evolution) => {
            })
            .then(_ => {
                if (data.evolutionOperator) {
                    this.evolutionsFacade.postEvolution(data.evolutionOperator, false)
                }
            })
            .then(_ => this.loadingConfirmEndTask = false)
            .then(_ => {
                swalWithCustomizeButtons.fire({
                    text: this.experienceI18n.translate('modules.cases.evolutions.messages.evolution-managed', undefined, 'Evolución gestionada correctamente'),
                    icon: 'success'
                });
            })
            .catch(err => this.loadingConfirmEndTask = false)
    }

    onClickOptionToExport(option: string) {
        this.showVisibilityCheckbox = this.showVisibilityOptions(option);
        this.exportForm = this.createExportForm();
        this.onSubmitExportFunction = this.onSubmitExport(option);
        switch (option) {
            case OPTIONS_TO_EXPORT.CSV:
                this.onSubmitExportFunction();
                break;
            case OPTIONS_TO_EXPORT.PDF:
                this.showOptions = true
                break;
            case OPTIONS_TO_EXPORT.ZIP:
                this.showOptions = true
                break;

            default:
                console.error('INCORRECT OPTION TO EXPORT');
                break;
        }

    }

    createFilterForm(): FormGroup {
        return this.formBuilder.group({
            [this.DATE_FROM]: ['', [CustomValidators.required(this.experienceI18n.translate('modules.cases.evolutions.validators.date-required', undefined, 'Fecha requerida'))]],
            [this.DATE_TO]: ['', [CustomValidators.required(this.experienceI18n.translate('modules.cases.evolutions.validators.date-required', undefined, 'Fecha requerida'))]],
        })
    }

    createExportForm(): FormGroup {
        return this.formBuilder.group({
            // [this.DATE_FROM]: ['', [CustomValidators.required('Fecha requerida')]],
            // [this.DATE_TO]: ['', [CustomValidators.required('Fecha requerida')]],
            [this.LOGO]: [LogoOptions.COMPANY_LOGO, [CustomValidators.required(this.experienceI18n.translate('modules.cases.evolutions.validators.status-required', undefined, 'Estado requerido'))]],
            [this.LOAD_FILE]: [''],
            [this.OUTPUT_TYPE]: [OutputOptions.UNIQUE_FILE],
            [this.VISIBLE_FINANCIER]: [false],
            [this.VISIBLE_PROVIDER]: [false],
        }, {
            validators: [
                CustomValidators.CVFromToDate(this.experienceI18n.translate('modules.cases.evolutions.validators.to-date-greater-than-from', undefined, 'La fecha de finalización debe ser superior a la de inicio'), 'errorDate', this.DATE_FROM, this.DATE_TO),
                CustomValidators.requiredDependingOnControlValue(this.experienceI18n.translate('modules.cases.evolutions.validators.logo-required', undefined, 'El logo es requerido'), 'errorDepending', this.LOAD_FILE, this.LOGO, LogoOptions.CUSTOM_LOGO)
            ]
        });
    }

    calculateIdlogo(element) {
        return element ? element.id : null;
    }

    calculateNameLogo(element) {
        return element ? element.name : null;
    }

    calculateIdOutput(element) {
        return element ? element.id : null;
    }

    calculateNameOutput(element) {
        return element ? element.name : null;
    }

    onSubmitExport(option: string) {
        return () => {
            switch (option) {
                case OPTIONS_TO_EXPORT.PDF: {
                    this.exportAsPdf();
                    break;
                }
                case OPTIONS_TO_EXPORT.ZIP: {
                    this.evolutionsPdf = this.filterAndSortAttentionsToExport();
                    this.exportAsZip()
                    break;
                }
                case OPTIONS_TO_EXPORT.CSV: {
                    this.exportAsXLSX();
                    break;
                }

                default:
                    break;
            }
        }
        // Obtener las imagenes de las evoluciones
    }

    exportAsPdf() {
        let evolutionsPdfQPS: EvolutionPdfQPS = {
            caseId: this.case.id,
            financierId: this.case.financier.id,
        }
        let output = this.exportForm.get(this.OUTPUT_TYPE).value;
        switch (output) {
            case this.OUTPUT_OPTIONS.UNIQUE_FILE:
                evolutionsPdfQPS.groupByPractice = false;
                evolutionsPdfQPS.groupByPracticeAndProvider = false;
                break;
            case this.OUTPUT_OPTIONS.BY_PRACTICE:
                evolutionsPdfQPS.groupByPractice = true;
                evolutionsPdfQPS.groupByPracticeAndProvider = false;
                break;
            case this.OUTPUT_OPTIONS.BY_PROVIDER_PRACTICE:
                evolutionsPdfQPS.groupByPractice = false;
                evolutionsPdfQPS.groupByPracticeAndProvider = true;
                break;
        }
        let logo = this.exportForm.get(this.LOGO).value;
        switch (logo) {
            case this.LOGO_OPTIONS.NO_LOGO:
                evolutionsPdfQPS.isWithTenantLogo = false;
                evolutionsPdfQPS.image = null;
                break;
            case this.LOGO_OPTIONS.CUSTOM_LOGO:
                evolutionsPdfQPS.isWithTenantLogo = false;
                evolutionsPdfQPS.image = this.loadFileForm;
                break;
            case this.LOGO_OPTIONS.COMPANY_LOGO:
                evolutionsPdfQPS.isWithTenantLogo = true;
                evolutionsPdfQPS.image = null;
                break;
        }
        evolutionsPdfQPS.fromDate = moment(this.caseDateFilters.historyFromDate).format('YYYY-MM-DD');
        evolutionsPdfQPS.toDate = moment(this.caseDateFilters.historyToDate).format('YYYY-MM-DD');
        evolutionsPdfQPS.isHideFromFinancier = this.exportForm.get(this.VISIBLE_FINANCIER).value;
        evolutionsPdfQPS.isHideFromProvider = this.exportForm.get(this.VISIBLE_PROVIDER).value;

        if (!!this.filterOnProvisions) {
            if (!!this.filterOnProvisions.agreements && this.filterOnProvisions.agreements.length > 0) {
                evolutionsPdfQPS.agreementsIds = this.filterOnProvisions.agreements.map(agr => agr.id);
            }

            if (!!this.filterOnProvisions.provisionFees && this.filterOnProvisions.provisionFees.length > 0) {
                evolutionsPdfQPS.provisionFeeIds = this.filterOnProvisions.provisionFees.map(provFee => provFee.id);
            }
        }

        if (!!this.categoriesSelected && this.categoriesSelected.length > 0) {
            evolutionsPdfQPS.categoriesIds = this.categoriesSelected;
        }

        evolutionsPdfQPS.onlyCover = false;

        this.casesFacade.loadgetEvolutionsPDF(evolutionsPdfQPS).subscribe((files => {
            for (let file of files) {
                this.downloadPdf(file, 'evoluciones_adomicilio_' + new Date().toISOString());
            }
        }))

    }

    downloadPdf(base64String, fileName) {
        const source = base64String;
        const link = document.createElement("a");
        link.href = source;
        link.download = `${fileName}.pdf`
        link.click();
    }

    showVisibilityOptions(option: string) {
        return ((option == OPTIONS_TO_EXPORT.PDF) || (option == OPTIONS_TO_EXPORT.ZIP));
    }

    filterAndSortAttentions(): AttentionComposedWithEvolutions[] {

        this.filterEvolutions();
        let attentionsToFilter = this.attentions;

        this.practices = [];
        this.mapAttentionsPracticesToExport(attentionsToFilter);
        console.log("Evolutions filtered: ", attentionsToFilter);
        return attentionsToFilter;
    }

    private filterAndSortAttentionsToExport(): AttentionComposedWithEvolutions[] {
        /**
         * Spread operator makes a shallow copy of data, so if i wanna change a property of the copy of a attention then the change
         * will be reflected on the original array. This problem has solved with the next map of original array with spread operator
         * for each one element.
         */
        let finalAttentionToExport: AttentionComposedWithEvolutions[] = this.attentions.filter(attention => (!!attention.id)).map(a => { return { ...a } });
        if (!this.exportForm.get(this.VISIBLE_PROVIDER).value) {
            finalAttentionToExport.forEach(att => {
                att.evolutions = [...att.evolutions.filter(evol => !!evol.visibleProvider)];
            })
        }
        if (!this.exportForm.get(this.VISIBLE_FINANCIER).value) {
            finalAttentionToExport.forEach(att => {
                att.evolutions = [...att.evolutions.filter(evol => !!evol.visibleFinancier)];
            })
        }
        finalAttentionToExport = [...finalAttentionToExport.filter(att => !!att.evolutions && att.evolutions.length > 0)];

        this.practices = [];
        this.mapAttentionsPracticesToExport(finalAttentionToExport);
        return finalAttentionToExport;
    }

    exportAsZip() {
        let files: { ext: string, data: string, title: string, date: string }[] = [];
        // TODO: Renombrar evolutionsPdf a attentionsPdf
        this.evolutionsPdf.forEach((attention: Attention, indexAttention) => attention.evolutions.forEach((evolution: Evolution, indexEvolution) => {
            // TODO: hardcodeado con [0] -> No aceptará multiples archivos
            if (!!evolution.media && !!evolution.media.mediaUrls) {
                evolution.media.mediaUrls.forEach(mediaUrl => {
                    const file = mediaUrl;
                    if (!!file) {
                        const ext = this.fileUtilitiesService.getExtension(file);
                        const data = this.fileUtilitiesService.getContent(file);
                        // Busco archivos con la misma fecha de evolución (para poner el numerado luego de la fecha)
                        const sameFiles = files.filter(file => file.date == moment(evolution.date).format('DD-MM-YYYY'))
                        const title = `${moment(evolution.date).format('DD-MM-YYYY')} - ${sameFiles.length + 1}`;
                        this.evolutionsPdf[indexAttention].evolutions[indexEvolution]['fileNamePdf'] = title;
                        files.push({ ext, data, title, date: moment(evolution.date).format('DD-MM-YYYY') });
                    }
                });
            }
        }))
        //   this.exportAsService.get(this.exportAsPDFConfig).subscribe(content => {
        //      const cont = this.fileUtilitiesService.getContent(content);
        //      this.fileUtilitiesService.downloadZip({ data: cont, ext: 'pdf' }, files, 'evoluciones_adomicilio_', 'Evoluciones')
        //   }); FIXME: FER
    }

    exportAsXLSX(): void {
        this.showOptions = false;
        const evolutionsExcel = this.evolutionsToExcelFormat(this.attentions, this.data.name, this.data.surname, this.data.document, this.data.cif);
        //   this.excelService.exportAsExcelFile(evolutionsExcel, 'evoluciones'); FIXME: FER
    }

    pdfCallbackFn(pdf: any) {
        // example to add page number as footer to every page of pdf
        const noOfPages = pdf.internal.getNumberOfPages();
        for (let i = 1; i <= noOfPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(10)
            pdf.text(this.experienceI18n.translate('modules.cases.evolutions.pdf.footer', { page: i, total: noOfPages }, 'Página {{page}} de {{total}}'), pdf.internal.pageSize.getWidth() - 35, pdf.internal.pageSize.getHeight() - 10);
        }
    }

    evolutionsToExcelFormat(attentions: AttentionComposedWithEvolutions[], patientName: string, patientSurname: string, patientDocument: string, cif: number): EvolutionExcel[] {
        let evolutionsExcel: EvolutionExcel[] = [];
        attentions.forEach(attention => {
            evolutionsExcel = evolutionsExcel.concat(attention.evolutions.map(
                evolution => {
                    let dateEvolution = moment(evolution.date).format("D/M/YYYY");
                    let dateAttention = moment(attention.fromDate).format("D/M/YYYY");
                    return {
                        FechaDeAtención: dateAttention,
                        Id: evolution.id,
                        CIF: cif ? cif : null,
                        FechaDeEvolución: dateEvolution,
                        Nombre: patientName,
                        Apellido: patientSurname,
                        Documento: patientDocument,
                        Texto: evolution.text,
                        Tipo: evolution.category.description,
                    }
                }
            ));

        });
        return evolutionsExcel;

    }

    getDateNow() {
        return new Date();
    }

    getProviderString(evolution: Evolution) {
        let providerString = this.experienceI18n.translate('modules.cases.evolutions.provider.no-data', undefined, 'Sin datos');
        /*       if (!!evolution.operator && !!evolution.operator.name) {
                 providerString = evolution.operator.name + (this.entitiesFacade.getProvidersFullName(evolution.provider) ? ` <span class="text-secondary">(en nombre de ${this.entitiesFacade.getProvidersFullName(evolution.provider)})</span>` : '');
              } else {
                 if (!!evolution.provider && !!this.entitiesFacade.getProvidersFullName(evolution.provider) && !!evolution.provider.specialties) { */
        let medicalLicencesToShow = '';
        let medicalLicences = [];
        evolution.provider.specialties.forEach(specialty => specialty.medicalLicenses.forEach(ml => medicalLicences.push(ml.value)));
        let medicalLicencesWithoutDuplicates = [...new Set(medicalLicences)];
        medicalLicencesWithoutDuplicates.forEach(medicalLicence => {
            medicalLicencesToShow += `${medicalLicence} `;
        })
        providerString = this.entitiesFacade.getProvidersFullName(evolution.provider) + (medicalLicencesToShow.length > 0 ? ` • <span class="text-secondary">${this.experienceI18n.translate('modules.cases.evolutions.provider.license-abbreviation', undefined, 'Mat.')}: ${medicalLicencesToShow} </span>` : '');
        //}
        //}
        return providerString;
    }

    openCreateEvolution() {
        this.updatingEvolution = false;
        this.evolutionToUpdate = null;
        const dialogRef = this.openDialog(
            this.case,
            this.experienceI18n.translate('modules.cases.evolutions.dialog.evolve-title', undefined, 'Evolucionar'),
            this.addEvolutionForCase,
            { maxHeight: '95vh', minWidth: '65%' },
            () => { }
        );
        this._dialogRef.afterClosed().subscribe(() => this.financierVisibility = false, this.providersVisibility = false, this.evolutionForm.reset());
    }

    createEvolutionForm(): FormGroup {
        if (this.updatingEvolution) {
            return this.formBuilder.group({
                [this.EVOLUTION_TEXT]: [(this.evolutionToUpdate.text) ? this.evolutionToUpdate.text : '', [CustomValidators.required(this.experienceI18n.translate('modules.cases.evolutions.validators.text-required', undefined, 'Texto requerido')), CustomValidators.minLength(10, this.experienceI18n.translate('modules.cases.evolutions.validators.text-min-length', undefined, 'La evolución debe tener al menos 10 caracteres'))]],
                [this.EVOLUTION_TYPE]: [(this.evolutionToUpdate.category) ? this.evolutionToUpdate.category.id : '', [CustomValidators.required(this.experienceI18n.translate('modules.cases.evolutions.validators.type-required', undefined, 'Tipo requerido'))]],
                [this.ADD_TASK]: [''],
                [this.OPERATOR]: [''],
                [this.OPERATOR_SEARCHING]: [''],
            });
        } else {
            return this.formBuilder.group({
                [this.EVOLUTION_TEXT]: ['', [CustomValidators.required(this.experienceI18n.translate('modules.cases.evolutions.validators.text-required', undefined, 'Texto requerido')), CustomValidators.minLength(10, this.experienceI18n.translate('modules.cases.evolutions.validators.text-min-length', undefined, 'La evolución debe tener al menos 10 caracteres'))]],
                [this.EVOLUTION_TYPE]: ['', [CustomValidators.required(this.experienceI18n.translate('modules.cases.evolutions.validators.type-required', undefined, 'Tipo requerido'))]],
                [this.ADD_TASK]: [''],
                [this.OPERATOR]: [''],
                [this.OPERATOR_SEARCHING]: [''],
            });
        }
    }

    openDialog(data: Case, title: string, template, style: { minWidth: string, maxHeight: string }, afterClosed?): void {
        this._dialogRef = this.dialog.open(DialogComponent, {
            disableClose: true,
            minWidth: style.minWidth,
            maxHeight: style.maxHeight,
            data: { template, title, data },
        });
        this._dialogRef.afterClosed().subscribe(() => afterClosed());
    }

    getDate(evolution: Evolution): Date {
        if (evolution.attentionId) {
            let attention: Attention = this.getAttentionById(evolution.attentionId);
            return (attention?.fromDate) ? attention?.fromDate : undefined;
        } else {
            return (evolution.date) ? evolution.date : undefined;
        }
    }

    // Show media on demand (avoid fetching media when listing evolutions)
    downloadMedia(data: Evolution) {
        // show per-item spinner
        this.evolutionIdGettingMedia = data.id;
        this.isloadingGettingMedia = true;
        this.cd.detectChanges();
        this.evolutionsFacade.getMediaByEvolutionId(data.id).subscribe(mediaFiles => {
            if (mediaFiles && mediaFiles.mediaUrls && mediaFiles.mediaUrls.length > 0) {
                mediaFiles.mediaUrls.forEach(elem => {
                    if (this.fileUtilitiesService.isPdf(elem)) {
                        this.fileUtilitiesService.downloadFile(elem)
                    } else if (this.fileUtilitiesService.isPhoto(elem)) {
                        this.openDialogImage(elem)
                    }
                })
            }
            // clear spinner id (keep behavior consistent with side-bar)
            this.evolutionIdGettingMedia = null;
            this.isloadingGettingMedia = false;
            this.cd.detectChanges();
        }, (err) => {
            // clear spinner id on error
            this.evolutionIdGettingMedia = null;
            this.isloadingGettingMedia = false;
            this.cd.detectChanges();
            console.error('Error getting media for evolution', data?.id, err);
        })
    }

    /**
     * Helper to decide if the "Ver adjunto" link should be shown for an evolution.
     * We show it when hasMedia is explicitly true, when hasMedia is null (unknown),
     * or when media/mediaUrls are already present on the evolution object.
     */
    public shouldShowMediaLink(evolution: Evolution): boolean {
        if (!evolution) { return false; }
        // evolution.hasMedia can be boolean or string or null - accept null as possible
        const hasMediaAny = (evolution as any).hasMedia;
        // Debug info to help diagnose why the link may not be shown in the template
        // debug logging removed
        // Show link when explicitly flagged or when a mediaUuid exists (new contract) or when mediaUrls already present
        if (hasMediaAny === true || hasMediaAny === 'true') { return true; }
        if (!!(evolution as any).mediaUuid) { return true; }
        if (!!evolution.media && !!evolution.media.mediaUrls && evolution.media.mediaUrls.length > 0) { return true; }
        if (!!evolution.mediaUrls && evolution.mediaUrls.length > 0) { return true; }
        return false;
    }

    getAttentionById(id: number): Attention {
        return this.attentions.find(att => att.id == id);
    }

    loadAttentionsAndEvolution() {
        this.sortEvolutionsByAttentionDate();
        this.setAttentionForNav();
        this.mapAttentionsPractices();
    }

    onCancelClick() {
        this._dialogRef.close();
    }

    onConfirmClick() {
        this.loadingConfirm = true;
        let postEvolutionObject: PostEvolutionBody;
        if (!!this.updatingEvolution) {
            postEvolutionObject = {
                caseId: this.case.id,
                financierId: this.case?.financierId ?? this.case?.financier?.id,
                patientId: this.case?.patientId ?? this.case?.patient?.id,
                text: this.evolutionText.value,
                type: EvolutionsType.NORMAL,
                categoryId: this.evolutionType.value,
                date: new Date(),
                mediaUrls: [this.photoEvolutionB64],
                visibleFinancier: this.financierVisibility,
                visibleProvider: this.providersVisibility,
                referencedEvolution: this.evolutionToUpdate.id,
                taskOperatorId: this.evolutionForm.get(this.OPERATOR).value,
                addTask: this.isAddingTask
            };
        } else {
            postEvolutionObject = {
                caseId: this.case.id,
                financierId: this.case?.financierId ?? this.case?.financier?.id,
                patientId: this.case?.patientId ?? this.case?.patient?.id,
                text: this.evolutionText.value,
                type: EvolutionsType.NORMAL,
                categoryId: this.evolutionType.value,
                date: new Date(),
                mediaUrls: [this.photoEvolutionB64],
                visibleFinancier: this.financierVisibility,
                visibleProvider: this.providersVisibility,
                taskOperatorId: this.evolutionForm.get(this.OPERATOR).value,
                addTask: this.isAddingTask
            };
        }
        console.log(JSON.stringify(postEvolutionObject));
        this.postEvolution(postEvolutionObject);
    }

    // //Temporarily show the evolution in the evolution list
    emulateAttentionWithEvolution(evolution) {
        if (!evolution?.id || this.hasEvolutionLoaded(evolution.id)) {
            return;
        }
        const attention = {
            fromDate: evolution.date,
            caseId: evolution.caseId,
            evolutions: [evolution]
        }
        // Ensure attentionsPreviousFilter is initialized before pushing
        this.attentionsPreviousFilter = !!this.attentionsPreviousFilter ? this.attentionsPreviousFilter : [];
        this.attentionsPreviousFilter.push(attention);
        this.filterEvolutions();
        this.cd.detectChanges();
        return;
    }

    private hasEvolutionLoaded(evolutionId: number): boolean {
        if (!evolutionId) {
            return false;
        }

        const collections = [this.attentions, this.attentionsPreviousFilter];
        return collections.some(attentions =>
            (attentions || []).some(attention =>
                (attention?.evolutions || []).some(evolution => evolution?.id === evolutionId)
            )
        );
    }

    postEvolution(evolution) {
        this.evolutionsFacade.postEvolution(evolution, true).subscribe(
            (evolution) => {
                if (!!evolution) {
                    this.emulateAttentionWithEvolution(evolution);
                }
                this.loadingConfirm = false;
                this._dialogRef.close(evolution);
            },
            (error) => {
                this.loadingConfirm = false;
                this.alertService.openError(error.message)
            }
        );
    }

    pondHandleInit() {
        console.log('Uploading....');
    }

    pondHandleAddFile(event: any) {
        if (!event.error) {
            const b64 = event.file.getFileEncodeBase64String();
            const extension = event.file.fileExtension;
            const mimeType = mime.getType(extension);;
            this.photoEvolutionB64 = `data:${mimeType};base64,${b64}`;
        } else {
            this.photoEvolutionB64 = null;
        }
        this.loadingAddFile = false;
    }

    pondHandleRemoveFile(event) {
        this.photoEvolutionB64 = null;
    }

    pondHandleProcessFile(event) {
        this.loadingAddFile = true;
    }

    calculateId(element: CategoryOfEvolution) {
        return element ? element.id : null;
    }

    calculateName(element: CategoryOfEvolution) {
        return element ? element.description : null;
    }

    onSelectCategory(id: number) {
        let categorySelected: CategoryOfEvolution = this.listEvolutionTypes.find(category => category.id == id);
        if (categorySelected) {
            this.financierVisibility = (categorySelected.visibleFinancier && categorySelected.visibleFinancier == 1) ? true : false;
            this.providersVisibility = (categorySelected.visibleProvider && categorySelected.visibleProvider == 1) ? true : false;
            if (!this.changeTextDescription) {
                if (categorySelected.defaultText && this.defaultTextCharged !== categorySelected.defaultText) {
                    this.evolutionText.setValue(categorySelected.defaultText);
                    this.defaultTextCharged = categorySelected.defaultText;
                } else {
                    this.evolutionText.setValue("");
                }
            }
        }
    }

    onChangeDescription(event) {
        let categorySelected: CategoryOfEvolution = this.listEvolutionTypes.find(category => category.id == this.evolutionType.value);
        if (categorySelected && event.target.value != '') {
            this.changeTextDescription = (categorySelected.defaultText != event.target.value);
        } else {
            if (event.target.value == '') {
                this.changeTextDescription = false;
            } else {
                this.changeTextDescription = (!categorySelected);
            }
        }
    }

    selectOption(option: MatSelectChange) {
        this.categoriesSelected = [...option.value];
    }

    removeFilter() {
        this.categoriesSelected = [];
        this.attentions = !!this.attentionsPreviousFilter ? [...this.attentionsPreviousFilter] : this.attentions;
        this.dateToForm = null;
        this.dateFromForm = null;
        this.filterEvolutions();
        this.setAttentionForNav();
    }

    onClickFilter() {
        this.attentionsPreviousFilter = !this.attentionsPreviousFilter ? [...this.attentions] : this.attentionsPreviousFilter;
        if (!!this.dateFromForm || !!this.categoriesSelected) {
            this.attentions = [...this.attentionsPreviousFilter];
            if (!!this.dateFromForm && !this.dateToForm) {
                this.dateToForm = moment().toDate();
            }
            this.attentions = this.filterAndSortAttentions();
            this.setAttentionForNav();
        }
    }

    getLabelDate() {
        return this.dateService.getSameFormatDateToDateRange(this.caseDateFilters.historyFromDate, this.caseDateFilters.historyToDate);
    }

    filterDisplayEvolutions(evolutions: Evolution[]): Evolution[] {
        return (evolutions ?? []).filter(e => e?.category?.id !== EvolutionCategoryId.ANALISIS_IA);
    }

    shouldShowAiReview(evolution: Evolution): boolean {
        return evolution?.category?.id !== EvolutionCategoryId.ANALISIS_IA && !!evolution?.aiStatus;
    }

    hasAuditorFeedback(evolution: Evolution): boolean {
        return evolution?.auditorScore != null || !!(evolution?.auditorNotes?.trim());
    }

    auditorDisplayName(evolution: Evolution): string {
        const cached = evolution?.id != null ? this.auditorNameByEvolutionId.get(evolution.id) : undefined;
        if (cached) {
            return cached;
        }
        return this.currentOperatorDisplayName();
    }

    private currentOperatorDisplayName(): string {
        const u = this.authService.userValue as { fullName?: string; name?: string; surname?: string; username?: string };
        if (!u) {
            return '';
        }
        if (u.fullName?.trim()) {
            return u.fullName.trim();
        }
        const composed = [u.name, u.surname].filter(Boolean).join(' ').trim();
        return composed || u.username || '';
    }

    aiStatusLabel(status: string): string {
        const key = `modules.cases.evolutions.ai-review.status.${(status || '').toLowerCase()}`;
        const fallbacks: Record<string, string> = {
            pending: 'Análisis pendiente',
            processing: 'Análisis en curso',
            analyzed: 'Revisión IA',
            failed: 'Análisis fallido',
        };
        return this.experienceI18n.translate(key, undefined, fallbacks[(status || '').toLowerCase()] ?? status);
    }

    isAiExpanded(evolutionId: number): boolean {
        return this.aiExpandedIds.has(evolutionId);
    }

    getCachedAnalysis(evolutionId: number): EvolutionAiAnalysis | undefined {
        return this.aiAnalysisCache.get(evolutionId);
    }

    toggleAiExpanded(evolution: Evolution): void {
        const id = evolution.id;
        if (!id) {
            return;
        }
        if (this.aiExpandedIds.has(id)) {
            this.aiExpandedIds.delete(id);
            this.cd.markForCheck();
            return;
        }
        this.aiExpandedIds.add(id);
        if (!this.aiAnalysisCache.has(id)) {
            this.evolutionsService.getAiAnalysis(id).subscribe({
                next: (analysis) => {
                    this.aiAnalysisCache.set(id, analysis);
                    this.cd.markForCheck();
                },
                error: () => {
                    this.alertService.openError(
                        this.experienceI18n.translate(
                            'modules.cases.evolutions.ai-review.load-error',
                            undefined,
                            'No se pudo cargar el análisis IA',
                        ),
                    );
                },
            });
        }
        this.cd.markForCheck();
    }

    openRateDialog(evolution: Evolution): void {
        const open = (analysis?: EvolutionAiAnalysis) => {
            const ref = this.dialog.open(RateEvolutionDialogComponent, {
                width: '520px',
                data: { evolution, analysis: analysis ?? this.aiAnalysisCache.get(evolution.id) },
            });
            ref.afterClosed().subscribe((updated: Evolution | false) => {
                if (!updated) {
                    return;
                }
                evolution.auditorScore = updated.auditorScore;
                evolution.auditorNotes = updated.auditorNotes;
                if (evolution.id) {
                    this.auditorNameByEvolutionId.set(evolution.id, this.currentOperatorDisplayName());
                    this.aiAnalysisCache.delete(evolution.id);
                    if (this.aiExpandedIds.has(evolution.id)) {
                        this.evolutionsService.getAiAnalysis(evolution.id).subscribe(a => {
                            this.aiAnalysisCache.set(evolution.id, a);
                            this.cd.markForCheck();
                        });
                    }
                }
                this.cd.markForCheck();
            });
        };

        if (evolution.id && this.aiAnalysisCache.has(evolution.id)) {
            open(this.aiAnalysisCache.get(evolution.id));
            return;
        }
        if (!evolution.id) {
            open();
            return;
        }
        this.evolutionsService.getAiAnalysis(evolution.id).subscribe({
            next: (analysis) => {
                this.aiAnalysisCache.set(evolution.id, analysis);
                open(analysis);
            },
            error: () => open(),
        });
    }
}
